// extracted by mini-css-extract-plugin
export var button = "_ad-4";
export var hasDarkBackground = "_ad-7";
export var hasLightBackground = "_ad-6";
export var iconWrapper = "_ad-0";
export var large = "_ad-2";
export var medium = "_ad-1";
export var small = "_ad-5";
export var xsmall = "_ad-3";